var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showImage)?_c('img',{staticClass:"KeybeAvatar-img",style:({
    minWidth: _vm.size+'px',
    minHeight: _vm.size+'px',
    maxWidth: _vm.size+'px',
    maxHeight: _vm.size+'px',
    objectFit: 'cover'
  }),attrs:{"src":_vm.isKeybeProfile? _vm.keybeLogo: _vm.img,"alt":""},on:{"error":function($event){_vm.imgUrl=''}}}):_c('div',{class:{smallText: _vm.small},style:(_vm.style)},[_vm._v(_vm._s(_vm.nameInitials))])}
var staticRenderFns = []

export { render, staticRenderFns }